import HomePage from "./pages/homePage";
import PersonDetailPage from "./pages/personDetailPage";
import PersonsFetch from "./tools/personsFetch";
import "./App.css"; // Genel stil dosyasını import ediyoruz

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";





function App() {
  const { persons} = PersonsFetch();


  return (
      <Router>
        <Routes>
          <Route path="/" element={<HomePage persons={persons}/>} />
          {persons.map(person => (
          <Route
            key={person.id}
            path={`/person/${person.id}`}
            element={<PersonDetailPage person={person} />}
          />
        ))}
        </Routes>
      </Router>
  );
}

export default App;
